import { createContext } from "react";
import { EntityModelGrantAndFunctionDto } from "openapi";
import { useUserGrants } from "../hooks/useUserGrants";

interface UserGrantsInitialState {
  userGrants: EntityModelGrantAndFunctionDto[] | undefined;
  userGrantsIsFetching: boolean;
  userGrantsError: string;
  getUserGrants: () => void;
}

const initialState: UserGrantsInitialState = {
  userGrants: undefined,
  userGrantsIsFetching: false,
  userGrantsError: "",
  getUserGrants: () => {},
};

export const UserGrantsContext = createContext(initialState);

export const UserGrantsProvider: React.FC<any> = ({ children }) => {
  const { userGrants, userGrantsError, userGrantsIsFetching, getUserGrants } =
    useUserGrants();

  return (
    <UserGrantsContext.Provider
      value={{
        userGrants,
        userGrantsError,
        userGrantsIsFetching,
        getUserGrants,
      }}
    >
      {children}
    </UserGrantsContext.Provider>
  );
};
